import React from 'react';
import classNames from 'classnames';

import s from './style.module.scss';

interface IBaseRadioButtonProps {
  id: string;
  name: string;
  label?: string;
  checked?: boolean;
  disabled?: boolean;
  loading?: boolean;
  value: string;
  rtl?: boolean;
  labelLeft?: boolean;
  labelRight?: boolean;
  onChange: (value: string) => void;
}

const BaseRadioButton: React.FC<IBaseRadioButtonProps> = (props) => {
  const {
    id,
    name,
    label,
    checked,
    onChange,
    disabled = false,
    loading = false,
    rtl = false,
    labelLeft = false,
    labelRight = false,
    ...rest
  } = props;

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event?.target?.value);
  };

  const bodyClassNames = classNames(s.body, {
    [s.rtl]: rtl,
  });

  const labelClassNames = classNames(s.label, {
    [s['label-left']]: labelLeft,
    [s['label-right']]: labelRight,
  });

  return (
    <div className={s['base-radio-button']}>
      <div className={bodyClassNames}>
        <input
          type="radio"
          id={id}
          name={name}
          className={s['radio-input']}
          checked={checked}
          onChange={handleRadioChange}
          disabled={disabled || loading}
          {...rest}
        />
        {label && (
          <label htmlFor={id} className={labelClassNames}>
            {label}
          </label>
        )}
      </div>
    </div>
  );
};

export default BaseRadioButton;
